import { Component } from "react"
import { Link } from "react-router-dom"
export default class ControlSidebar extends Component {
    // Click pe linkul din sidebar-ul din dreapta -> il inchide (navigare + close pe mobil),
    // la fel ca sidebar-ul din stanga. Simuleaza click pe butonul real de toggle din Navbar.
    closeIfOpen = () => {
        if (document.body.classList.contains('control-sidebar-slide-open')) {
            document.querySelector('[data-widget="control-sidebar"]')?.click();
        }
    };

    render() {
        return (
            <div>
                {/* Control Sidebar */}
                <aside className="control-sidebar control-sidebar-dark">
                    {/* Control sidebar content goes here */}

                    {/* Sidebar Menu */}
                    <nav className="mt-2" onClick={this.closeIfOpen}>
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                            data-accordion="false">
                            {/* Add icons to the links using the .nav-icon className
                            with font-awesome or any other icon font library */}
                            <li className="nav-item menu-open">
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <Link to="/login" className="nav-link">
                                            <i className="far fa-circle nav-icon"></i>
                                            <p>Login</p>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>
                </aside>
                {/* /.control-sidebar */}
            </div>
    )
    }
    }
